// Campus photo for /colleges/university-of-maryland-baltimore-county: CC BY-SA 2.0, by Tim Menzies, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAlbin_O._Kuhn_Library%2C_UMBC_Campus.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-maryland-baltimore-county/; credited under the photo.
const photo = {
    "slug": "university-of-maryland-baltimore-county",
    "alt": "The Albin O. Kuhn Library and its tower seen across the lawn at UMBC in Baltimore County, Maryland",
    "src": "/colleges/university-of-maryland-baltimore-county/campus-1600.webp",
    "srcSmall": "/colleges/university-of-maryland-baltimore-county/campus-800.webp",
    "srcMid": "/colleges/university-of-maryland-baltimore-county/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-maryland-baltimore-county/og.jpg",
    "title": "Albin O. Kuhn Library, UMBC Campus",
    "author": "Tim Menzies",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAlbin_O._Kuhn_Library%2C_UMBC_Campus.jpg",
    "read": "2026-10-02"
};

export default photo;
